/* eslint-disable jsx-a11y/label-has-for,react/no-danger,max-len */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../../helpers/config';
import { sites } from '../../helpers/globalVariables';
import ContainerSummary from './ContainerSummaryConnector';
import { formatPrice } from '../../helpers/formatNumbers';
import { classNames, boolClass } from '../../helpers/classNameHelpers';
import BuyWithProInstallationButton from './Purchasing/BuyWithProInstallationButton';
import EstimateSummaryModal from './EstimateSummaryModal';
import checkStoreAvailability from './Purchasing/availabilityApi/checkStoreAvailability';

class EstimateSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      isAvailableForMandi: true,
    };
  }

  componentDidMount = () => {
    if (config.siteId === sites.theHomeDepot) {
      if (config.repId() !== null) {
        this.setState({
          isAvailableForMandi: true,
        });
      } else {
        checkStoreAvailability()
          .then((response) => {
            this.setState({
              isAvailableForMandi: response.data.result,
            });
          })
          .catch(() => {
            this.setState({
              isAvailableForMandi: false,
            });
          });
      }
    }
  };

  isThdElement = (config.siteId === sites.theHomeDepot) ? ' thd' : '';

  toggleModal = () => this.setState({ isModalOpen: !this.state.isModalOpen });

  discountTotal = () => this.props.retail - this.props.subtotal;

  promoMessage = () => {
    let text = `${this.props.locale.promoCodeText.replace(
      '{{promoCode}}',
      this.props.promoCode,
    )}`;
    if (this.props.promoEndDate) {
      text += ` ${this.props.locale.promoEndDateText.replace(
        '{{promoEndDate}}',
        this.props.promoEndDate,
      )}`;
    }
    return text;
  };

  render = () => (
    <div className={classNames(['estimateSummary', this.props.className])}>
      <div className="pricingHeader">
        <span
          className="estimateName truncateText"
          title={`${this.props.name} ${this.props.locale.summaryHeader}`}
        >
          {this.props.name}
        </span>
        <span className="summary">{this.props.locale.summaryHeader}</span>
      </div>
      <div className="pricingDetails">
        <div className="summaryTotals">
          <div className="lineItems">
            {this.props.containerIds.map(id => <ContainerSummary containerId={id} key={id} />)}
          </div>
          <div className="shipping">
            <label className="name">{this.props.locale.shipping}</label>
            <span className="total">{this.props.locale.shippingFree}</span>
          </div>
          {this.discountTotal() > 0 && (
            <div className="youllSave">
              <label className="name">{this.props.locale.youllSave}</label>
              <span className="total">{formatPrice(this.discountTotal())}</span>
            </div>
          )}
          <div className="subTotal">
            <label>{this.props.locale.pretaxTotal}</label>
            <span>{formatPrice(this.props.subtotal)}</span>
          </div>

          <div className="summaryDetails tablet-mobile-only">
            <span>
              <a href="#details" onClick={(e) => { e.preventDefault(); this.toggleModal(); }}>
                Details
              </a>
            </span>
            <EstimateSummaryModal
              isOpen={this.state.isModalOpen}
              toggleModal={this.toggleModal}
              isAvailableForMandi={this.state.isAvailableForMandi}
              {...this.props}
            />
          </div>
        </div>

        <div
          className={classNames(['summaryActions', boolClass(this.props.isLinked, 'isSaved')])}
        >
          <div className="summaryAction buy-diy">
            <div>
              <button
                className="btn btn-primary"
                onClick={() => this.props.cartEstimate()}
                disabled={this.props.disableDiyCheckout}
              >
                <span>Buy Now</span>
              </button>
            </div>
          </div>
          {!this.props.isInStore && this.state.isAvailableForMandi && <div className="orSeperator">or</div>}
          {!this.props.isInStore && this.state.isAvailableForMandi && (
            <div className="summaryAction buy-pro">
              <BuyWithProInstallationButton
                disabled={this.props.disableProCheckout}
                text={this.props.locale.mandiButtonText}
                textMobile={this.props.locale.mandiButtonTextMobile}
              />
            </div>
          )}
        </div>
      </div>

      {this.props.promoCode && (
        <div className="promo-message">
          <span dangerouslySetInnerHTML={{ __html: this.promoMessage() }} />
        </div>
      )}
      {!this.props.isInStore && this.state.isAvailableForMandi && (
        <div className="mandi-message">
          <span>{this.props.locale.mandiText}</span>
        </div>
      )}
    </div>
  );
}

EstimateSummary.propTypes = {
  name: PropTypes.string.isRequired,
  subtotal: PropTypes.number,
  retail: PropTypes.number.isRequired,
  promoCode: PropTypes.string,
  promoEndDate: PropTypes.string,
  containerIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  cartEstimate: PropTypes.func.isRequired,
  disableDiyCheckout: PropTypes.bool.isRequired,
  disableProCheckout: PropTypes.bool.isRequired,
  className: PropTypes.string,
  isLinked: PropTypes.bool,
  locale: PropTypes.shape({
    summaryHeader: PropTypes.string.isRequired,
    shipping: PropTypes.string.isRequired,
    shippingFree: PropTypes.string.isRequired,
    pretaxTotal: PropTypes.string.isRequired,
    youllSave: PropTypes.string.isRequired,
    mandiButtonText: PropTypes.string.isRequired,
    mandiButtonTextMobile: PropTypes.string.isRequired,
    mandiText: PropTypes.string.isRequired,
    promoCodeText: PropTypes.string.isRequired,
    promoEndDateText: PropTypes.string.isRequired,
  }).isRequired,
  isInStore: PropTypes.bool.isRequired,
};

EstimateSummary.defaultProps = {
  className: '',
  isLinked: false,
  subtotal: 0,
  promoCode: null,
  promoEndDate: null,
};

export default EstimateSummary;
